import styled from "styled-components";
import Button from "../../../../../components/Button";

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  width: 100%;

  @media(min-width: 768px){
    flex-direction: row;
    justify-content: flex-end;
  }
`;

export const CloseButton = styled(Button)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
`;

export const CopyButton = styled(Button)`
  font-size: 16px;
  margin: 0;
  border-radius: 20px;
  font-weight: 500;
  line-height: 36px;
  height: 40px;
`;

export const Title = styled.h2`
  font-weight: 500;
  font-size: 18px;
  line-height: normal;
  color: #2D3436;
  margin: 0px;
  text-align: center;
`;

export const Subtitle = styled.p`
  font-size: 12px;
  line-height: normal;
  color: #2D3436;
  margin: 0px;
  text-align: center;
`;


export const Text = styled.p`
  font-size: 14px;
  line-height: 20px;
  color: #2D3436;
  margin: 12px 0;
  
  b {
    font-weight: 600;
  }
`;

export const List = styled.ul`
  margin: 12px 0;
  padding-left: 20px;
`;

export const ListItem = styled.li`
  font-size: 14px;
  line-height: 20px;
  color: #2D3436;
  margin: 8px 0;
`;

